export default "__VITE_ASSET__D618JkGV__"